import { SingleSearchParam } from "./SingleSearchParam";

export class IngestionsSearchParams {

  page: SingleSearchParam;
  sortBy: SingleSearchParam;
  sortDir: SingleSearchParam;
  q: SingleSearchParam;

  serialized: string;
  
  constructor(params: any) {
    this.page = new SingleSearchParam(params.page || 1)
    this.sortBy = new SingleSearchParam(params.sortBy)
    this.sortDir = new SingleSearchParam(params.sortDir)
    this.q = new SingleSearchParam(params.q || '')
    this.serialized = this.serialize()
  }

  serialize(page?: string) {
    const searchParams = new URLSearchParams()
    searchParams.set('q', this.q.serialize());
    searchParams.set('page', page ? page : this.page.serialize());
    searchParams.set('sortBy', this.sortBy.serialize());
    searchParams.set('sortDir', this.sortDir.serialize());
    return searchParams.toString()
  }

  raw() {
    return {
      page: this.page.value,
      sortBy: this.sortBy.value,
      sortDir: this.sortDir.value,
      q: this.q.value,
      serialized: this.serialized
    }
  }

  toBody() {
    return {
      page: this.page.value,
      sortBy: this.sortBy.value,
      sortDir: this.sortDir.value,
      q: this.q.value,
    }
  }
}